/**
 * Hook to retrieve the workspace folders[]
 */

import { useQuery } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { getWorkspaceFolders } from '../../../api/workspaces/folders/getWorkspaceFolders';
import { WorkspaceFolder } from '../../../api/workspaces/folders/types';

export function useWorkspaceFolders<T = WorkspaceFolder[]>({
  workspaceId,
  select,
  isDeleted,
  enabled = true,
}: {
  workspaceId: string;
  isDeleted?: boolean;
  select?: (workspaceFolders: WorkspaceFolder[]) => T;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: workspaceKeys.folders({ workspaceId, isDeleted }),
    queryFn: () => getWorkspaceFolders({ workspaceId, isDeleted }),
    select,
    enabled,
  });
}
